// Utility functions for handling customization display

/**
 * Add appropriate prefix to customization text based on item name
 */
export const addCustomizationPrefix = (itemName: string, customText: string): string => {
  const lowerName = itemName.toLowerCase();
  
  if (lowerName === 'beadcolor') {
    return `bead-${customText}`;
  } else if (lowerName.includes('base') || lowerName.includes('background')) {
    return `back-${customText}`;
  } else if (lowerName.includes('text') || lowerName.includes('name') || lowerName.includes('number')) {
    return `text-${customText}`;
  }
  
  return customText;
};

/**
 * Format customization items for display with prefixes
 */
export const formatCustomizationForDisplay = (customizationItems: any[]): string => {
  return customizationItems
    .map(item => addCustomizationPrefix(item.name, item.customText))
    .join(', ');
};

/**
 * Test function to verify prefix logic works correctly
 */
export const testPrefixLogic = () => {
  const testItems = [
    { name: 'Name', customText: 'John Smith' },
    { name: 'BaseColor', customText: 'JADE WHITE' },
    { name: 'TextColor', customText: 'BLACK' },
    { name: 'BeadColor', customText: 'WHITE' },
    { name: 'Number', customText: '42' }
  ];
  
  const result = formatCustomizationForDisplay(testItems);
  console.log('Prefix test result:', result);
  // Expected: "text-John Smith, back-JADE WHITE, text-BLACK, bead-WHITE, text-42"
  return result;
};
